// extracted by mini-css-extract-plugin
export var smallSpinner = "_ql-0";